import React from 'react';
import { useNavigate } from 'react-router';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Avatar } from '@producer/ui-kit';
import { observer } from 'mobx-react-lite';

import { SpaceMenu } from '../space-menu';
import { SpaceSelector } from '../space-selector';
import { ProducerLogo } from '../../../components/logo/producer-logo';
import { uiStore } from '../../../core/stores/ui-store';

import type { DrawerComponentProps } from './drawer';

import styles from './main-drawer.module.scss';
export const MainDrawer: React.FC<DrawerComponentProps> = observer(
  ({ isOpen, currentUser, space }) => {
    const navigate = useNavigate();

    return (
      <div className={styles['container']}>
        <div className={styles['top-section']}>
          <ProducerLogo />

          <SpaceMenu space={space} onClose={() => (uiStore.isDrawerOpen = false)} />

          <SpaceSelector
            space={space}
            isOpen={isOpen}
            onClose={() => (uiStore.isDrawerOpen = false)}
          />
        </div>

        <div
          className={styles['user-wrapper']}
          onClick={() => {
            navigate(`/settings/profile`, { state: { prevPath: window.location.pathname } });
          }}
        >
          <div className={styles['current-user-div']}>
            <Avatar
              size="medium"
              src={currentUser.avatar}
              initials={currentUser.initials}
              theme="dark"
            />
            <div className={styles['user-name-email-wrapper']}>
              <span>{currentUser.fullName}</span>

              <span>{currentUser.email}</span>
            </div>
          </div>

          <div className={styles['icon-wrapper']}>
            <ChevronRightIcon color="var(--color-grayscale-light-slate, #7A8296)" />
          </div>
        </div>
      </div>
    );
  },
);
